import {Button, Modal, Select, Spin} from "antd";
import {useState} from "react";

export default function SampleProjectModal({onUpload}) {
    const [model, setModel] = useState(null)
    const [spinner, setSpinner] = useState(false)

    const onChange = async (val) => {
        setModel(val)
    }

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <Select
                size={'small'}
                onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                allowClear={true}
                value={model}
                onClear={() => onChange('model_a', null)}
                placeholder={'Model A - Select Sample HEC-RAS Model'}
                onChange={onChange}
                style={{flex: 1}}
            >
                <Select.Option value={'model_1'}>
                    Sample Model - Mill Creek Effective
                </Select.Option>
                <Select.Option value={'model_2'}>
                    Sample Model - Mill Creek LOMR
                </Select.Option>
            </Select>
            <Button
                onClick={async () => {
                    setSpinner(true)
                    const res = await fetch(`/sample/${model}.json`)
                    if(res.ok) {
                        onUpload && onUpload(await res.json())
                    }
                    setSpinner(false)
                }}
                type={'primary'}
                size={'small'}
            >
                Load Project
            </Button>
            <Spin spinning={spinner} />
        </div>
    )
}